import { z } from 'zod';
export const painSchema = z.object({
    id: z.string().optional(),
    location: z.string().min(1, 'Location is required'),
    level: z.string().min(1, 'Pain level is required'),
    character: z.string().optional(),
    onsetDuration: z.string().optional(),
    relievingAggravating: z.string().optional(),
    treatment: z.string().optional(),
    outcome: z.string().optional(),
});
